import niZhou from './index'
import niZhouHome from './Home'

const dataHistory = () => import('./../../components/DataHistory')
const gasClamp = () => import('./gasClamp')
const bridgeImg = () => import('./bridgeImg')
const login = () => import('./login.vue')
const prepStation = () => import('./prepStation.vue')
const dehumidifier = () => import('./dehumidifier.vue')
const circulatingFan = () => import('./circulatingFan.vue')
const highPressureFan = () => import('./highPressureFan.vue')
const boxGirder = () => import('./boxGirder.vue')
const highPressureFanLess = () => import('./highPressureFanLess.vue')
const anchorAfan = () => import('./anchorAfan.vue')
const prepStationBig = () => import('./prepStationBig.vue')

export default [
  {
    path: '/niZhouIndex',
    name: 'niZhouIndex',
    component: niZhouHome
  },
  {
    path: '/niZhou/login',
    name: 'niZhouLogin',
    component: login
  },
  {
    path: '/niZhou',
    name: 'niZhou',
    redirect: '/niZhou/prepStation1',
    component: niZhou,
    children: [
      {
        path: 'prepStation1',
        name: 'nizhou_prepStation1',
        redirect: '/niZhou/prepStation1/anchorAfan',
        component: prepStation,
        children: [
          {
            path: 'dehumidifierOne',
            name: 'nizhou_prepStation1_dehumidifierOne',
            component: dehumidifier
          },
          {
            path: 'anchorAfan',
            name: 'nizhou_prepStation1_anchorAfan',
            component: anchorAfan
          },
          {
            path: 'dehumidifierTwo',
            name: 'nizhou_prepStation1_dehumidifierTwo',
            component: dehumidifier
          }
        ]
      },
      {
        path: 'prepStation2',
        name: 'nizhou_prepStation2',
        redirect: '/niZhou/prepStation2/anchorAfan',
        component: prepStation,
        children: [
          {
            path: 'dehumidifierOne',
            name: 'nizhou_prepStation2_dehumidifierOne',
            component: dehumidifier
          },
          {
            path: 'anchorAfan',
            name: 'nizhou_prepStation2_anchorAfan',
            component: anchorAfan
          },
          {
            path: 'dehumidifierTwo',
            name: 'nizhou_prepStation2_dehumidifierTwo',
            component: dehumidifier
          }
        ]
      },
      {
        path: 'prepStation3',
        name: 'nizhou_prepStation3',
        redirect: '/niZhou/prepStation3/anchorAfan',
        component: prepStation,
        children: [
          {
            path: 'dehumidifierOne',
            name: 'nizhou_prepStation3_dehumidifierOne',
            component: dehumidifier
          },
          {
            path: 'anchorAfan',
            name: 'nizhou_prepStation3_anchorAfan',
            component: anchorAfan
          },
          {
            path: 'highPressureFanLess',
            name: 'nizhou_prepStation3_highPressureFanLess',
            component: highPressureFanLess
          },
          {
            path: 'dehumidifierTwo',
            name: 'nizhou_prepStation3_dehumidifierTwo',
            component: dehumidifier
          }
        ]
      },
      {
        path: 'prepStation4',
        name: 'nizhou_prepStation4',
        redirect: '/niZhou/prepStation4/anchorAfan',
        component: prepStation,
        children: [
          {
            path: 'dehumidifierOne',
            name: 'nizhou_prepStation4_dehumidifierOne',
            component: dehumidifier
          },
          {
            path: 'anchorAfan',
            name: 'nizhou_prepStation4_anchorAfan',
            component: anchorAfan
          },
          {
            path: 'highPressureFanLess',
            name: 'nizhou_prepStation4_highPressureFanLess',
            component: highPressureFanLess
          },
          {
            path: 'dehumidifierTwo',
            name: 'nizhou_prepStation4_dehumidifierTwo',
            component: dehumidifier
          }
        ]
      },
      {
        path: 'prepStation5',
        name: 'nizhou_prepStation5',
        redirect: '/niZhou/prepStation5/prepStationBig',
        component: prepStation,
        children: [
          {
            path: 'prepStationBig',
            name: 'nizhou_prepStation5_prepStationBig',
            component: prepStationBig
          },
          {
            path: 'circulatingFan',
            name: 'nizhou_prepStation5_circulatingFan',
            component: circulatingFan
          },
          {
            path: 'highPressureFan12',
            name: 'nizhou_prepStation5_highPressureFan12',
            component: highPressureFan
          },
          {
            path: 'highPressureFan34',
            name: 'nizhou_prepStation5_highPressureFan34',
            component: highPressureFan
          },
          {
            path: 'highPressureFan56',
            name: 'nizhou_prepStation5_highPressureFan56',
            component: highPressureFan
          },
          {
            path: 'boxGirder',
            name: 'nizhou_prepStation5_boxGirder',
            component: boxGirder
          },
          {
            path: 'dehumidifierOne',
            name: 'nizhou_prepStation5_dehumidifierOne',
            component: dehumidifier
          },
          {
            path: 'dehumidifierTwo',
            name: 'nizhou_prepStation5_dehumidifierTwo',
            component: dehumidifier
          },
          {
            path: 'dehumidifierThree',
            name: 'nizhou_prepStation5_dehumidifierThree',
            component: dehumidifier
          }
        ]
      },
      {
        path: 'prepStation6',
        name: 'nizhou_prepStation6',
        redirect: '/niZhou/prepStation6/prepStationBig',
        component: prepStation,
        children: [
          {
            path: 'prepStationBig',
            name: 'nizhou_prepStation6_prepStationBig',
            component: prepStationBig
          },
          {
            path: 'circulatingFan',
            name: 'nizhou_prepStation6_circulatingFan',
            component: circulatingFan
          },
          {
            path: 'highPressureFan12',
            name: 'nizhou_prepStation6_highPressureFan12',
            component: highPressureFan
          },
          {
            path: 'highPressureFan34',
            name: 'nizhou_prepStation6_highPressureFan34',
            component: highPressureFan
          },
          {
            path: 'highPressureFan56',
            name: 'nizhou_prepStation6_highPressureFan56',
            component: highPressureFan
          },
          {
            path: 'highPressureFan',
            name: 'nizhou_prepStation6_highPressureFan',
            component: highPressureFan
          },
          {
            path: 'boxGirder',
            name: 'nizhou_prepStation6_boxGirder',
            component: boxGirder
          },
          {
            path: 'dehumidifierOne',
            name: 'nizhou_prepStation6_dehumidifierOne',
            component: dehumidifier
          },
          {
            path: 'dehumidifierTwo',
            name: 'nizhou_prepStation6_dehumidifierTwo',
            component: dehumidifier
          },
          {
            path: 'dehumidifierThree',
            name: 'nizhou_prepStation6_dehumidifierThree',
            component: dehumidifier
          }
        ]
      },
      {
        path: 'bridgeImg',
        name: 'nizhou_bridgeImg',
        component: bridgeImg
      },
      {
        path: 'dataHistory',
        name: 'nizhou_DataHistory',
        component: dataHistory
      },
      {
        path: 'gasClamp',
        name: 'nizhou_gasClamp',
        component: gasClamp
      }
    ]
  }
]
